export const GET_AUDIT_PLANS = "GET_AUDIT_PLANS"
export const GET_AUDIT_PLANS_SUCCESS = "GET_AUDIT_PLANS_SUCCESS"
export const GET_AUDIT_PLAN_BY_ID = "GET_AUDIT_PLAN_BY_ID"
export const GET_AUDIT_PLAN_BY_ID_SUCCESS = "GET_AUDIT_PLAN_BY_ID_SUCCESS"
export const POST_AUDIT_PLAN = "POST_AUDIT_PLAN"
export const PATCH_AUDIT_PLAN = "PATCH_AUDIT_PLAN"
export const DUPLICATE_AUDIT_PLAN = "DUPLICATE_AUDIT_PLAN"
export const DELETE_AUDIT_PLAN = "DELETE_AUDIT_PLAN"
export const SUBMIT_AUDIT_PLAN = "SUBMIT_AUDIT_PLAN"
export const AUDIT_PLAN_IS_LOADING = "AUDIT_PLAN_IS_LOADING"
